import { render, staticRenderFns } from "./AppleAddToHomeScreenModal.vue?vue&type=template&id=2c8ba224&scoped=true&"
import script from "./AppleAddToHomeScreenModal.vue?vue&type=script&lang=js&"
export * from "./AppleAddToHomeScreenModal.vue?vue&type=script&lang=js&"
import style0 from "./AppleAddToHomeScreenModal.vue?vue&type=style&index=0&id=2c8ba224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8ba224",
  null
  
)

export default component.exports